// extracted by mini-css-extract-plugin
export default {"paper":"MARDialog_paper__5sDwu"};